function Home() {
  return (
    <main>
      <div className="center">
        <div className="centeredDiv">
          <img
            id="img_lowri"
            src={window.location.origin + "/images/lowri.png"}
            alt="Drawing of me, Lowri Roberts, on the island of Capri in Italy"
          />
          <div>
            <h1>Lowri Roberts</h1>
            <p>
              Check out my new website, which is still work in progress at:
              <a href="https://lowriroberts.vercel.app/home">
                https://lowriroberts.vercel.app/home
              </a>
              <br />
              <br />
              I hold a BSc (Hons) degree in Physics with Astrophysics from the
              University of Bath, and possess valuable experience as an
              Information Assistant in the hospitality industry. My areas of
              expertise include customer service, Microsoft Word, Microsoft
              Office and Social Media. <br />
              <br />
              As a passionate professional, I am dedicated to developing
              innovative and dynamic web applications that actively engage
              users. My skillset currently includes Python, C, and MATLAB, and I
              am currently enrolled in a NorthCoders boot camp to further
              enhance my proficiency in programming languages such as
              JavaScript, MySQL, HTML, and CSS. My degree has equipped me with
              strong problem-solving abilities and I enjoy applying these skills
              to real-world projects.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Home;
